import React, { useState } from "react";

const FilterPanel = ({ filters, selected, onChange, onApply, onClose }) => {
  const [local, setLocal] = useState({ ...selected });

  const toggle = (group, val) => {
    setLocal((prev) => {
      const cur = prev[group] || [];
      return {
        ...prev,
        [group]: cur.includes(val)
          ? cur.filter((x) => x !== val)
          : [...cur, val],
      };
    });
  };

  const selectAll = (group) => {
    setLocal((prev) => ({ ...prev, [group]: [...filters[group]] }));
  };

  const totalActive = Object.values(local).flat().length;

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: "calc(100% + 6px)",
        zIndex: 200,
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        width: 360,
        overflow: "hidden",
        fontFamily: "Segoe UI",
      }}
    >
      <div
        style={{
          padding: "14px 16px",
          borderBottom: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 15 }}>Filter</span>
        <span style={{ fontSize: 13, color: "#888" }}>
          Active Filters ({totalActive})
        </span>
        <button
          onClick={() => {
            setLocal({});
          }}
          style={{
            fontSize: 13,
            color: "#0ea5e9",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          Clear all
        </button>
      </div>

      <div style={{ maxHeight: 360, overflowY: "auto", padding: "12px 16px" }}>
        {Object.entries(filters).map(([group, options]) => (
          <div key={group} style={{ marginBottom: 16 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <span style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                {group.charAt(0).toUpperCase() + group.slice(1)}
              </span>

              <button
                onClick={() => selectAll(group)}
                style={{
                  fontSize: 12,
                  color: "#0ea5e9",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                select all
              </button>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {group === "location"
                ? options.map((opt) => {
                    const active = (local[group] || []).includes(
                      opt.location_id,
                    );
                    return (
                      <button
                        key={opt}
                        onClick={() => toggle(group, opt.location_id)}
                        style={{
                          padding: "5px 12px",
                          borderRadius: 20,
                          fontSize: 13,
                          cursor: "pointer",
                          border: active
                            ? "1.5px solid #0ea5e9"
                            : "1px solid #e2e8f0",
                          background: active ? "#e0f2fe" : "#fff",
                          color: active ? "#0369a1" : "#333",
                          transition: "all 0.15s",
                        }}
                      >
                        {opt.location_Name}
                      </button>
                    );
                  })
                : options.map((opt) => {
                    const active = (local[group] || []).includes(opt);
                    return (
                      <button
                        key={opt}
                        onClick={() => toggle(group, opt)}
                        style={{
                          padding: "5px 12px",
                          borderRadius: 20,
                          fontSize: 13,
                          cursor: "pointer",
                          border: active
                            ? "1.5px solid #0ea5e9"
                            : "1px solid #e2e8f0",
                          background: active ? "#e0f2fe" : "#fff",
                          color: active ? "#0369a1" : "#333",
                          transition: "all 0.15s",
                        }}
                      >
                        {opt}
                      </button>
                    );
                  })}
            </div>
          </div>
        ))}
      </div>

      <div style={{ padding: "12px 16px", borderTop: "1px solid #f1f5f9" }}>
        <button
          onClick={() => {
            onChange(local);
            onApply(local);
            onClose();
          }}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: 8,
            background: "#14b8a6",
            color: "#fff",
            fontWeight: 600,
            fontSize: 14,
            border: "none",
            cursor: "pointer",
          }}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
